import { computed } from "vue";
import { p as pick } from "../../../../vendor-2b2dbafd.mjs";
const useNativeImgAttributesProps = {
  src: { type: String, required: true },
  alt: { type: String, default: "" },
  title: { type: String, default: "" },
  sizes: { type: String, default: "" },
  srcset: { type: String, default: "" },
  draggable: { type: Boolean, default: true },
  loading: {
    type: String
  },
  crossorigin: {
    type: String
  },
  decoding: {
    type: String
  },
  fetchpriority: {
    type: String,
    default: "auto"
  },
  referrerpolicy: {
    type: String
  }
};
const useNativeImgAttributes = (props) => {
  return computed(
    () => pick(props, ["src", "alt", "title", "sizes", "srcset", "loading", "referrerpolicy", "fetchpriority", "decoding", "crossorigin", "draggable"])
  );
};
export {
  useNativeImgAttributes as a,
  useNativeImgAttributesProps as u
};
//# sourceMappingURL=useNativeImgAttributes-9ad714e2.mjs.map
